import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { publishReplay, refCount } from 'rxjs/operators';
import { roleMS, UserRoleMS } from '../../models/roleMS.model';
import { RoleUserMS } from '../../models/roleUserMS.model';
import { UserRoleModel } from '../../models/user.model';
import { HttpClientService } from '../httpClient/httpclient.service';
import { UsersService } from '../user/users.service';

@Injectable()
export class RoleUserMSService {
  currentRoleUsers: RoleUserMS[];
  private cachedFields: Observable<any>;

  constructor (
    private h: HttpClientService,
    private srvUsers: UsersService
  ) {
    this.currentRoleUsers = [];
  }

  createRoleDTO(roleUser: RoleUserMS): any {
    return {
      id: roleUser.id,
      role_id: roleUser.role.id,
      user_id: roleUser.user_id
    };
  }

  getAll(role: roleMS) {

    return this.h.get(role.ms_base_url + '/permissions/roleusers/' + role.id)
      .map(rus => {
        if (rus && rus.length > 0) {
          return {rus: rus, id_list: rus.map(ru => ru.user_id).reduce((id1, id2) => id1 + ',' + id2)}
        }
      })
      .concatMap(ruList => {
        if (ruList) {
          console.log('ruList', ruList);
          return this.srvUsers.getFiltereIdList(ruList.id_list).map(users => {
            return {rus: ruList.rus, users: users}
          })
        } else {
          return [];
        }
      })
      .map(ruList => {
        if (ruList) {
          this.currentRoleUsers = [];
          console.log('currentRoleUsers USR', ruList);
          ruList.users.forEach(u => {
            if (ruList.rus.find(ru => ru.user_id === u.id)) {
              this.currentRoleUsers.push({
                id: ruList.rus.find(ru => ru.user_id === u.id).id,
                user_id: u.id,
                role: role,
                user_name: u.name,
                user_surname: u.surname,
                user_login: u.login
              });
            }
          });
          console.log('currentRoleUsers', this.currentRoleUsers);
          return this.currentRoleUsers
        } else {
          return [];
        }
      })

  }

  post(roleUser: RoleUserMS) {
    let roleDTO = this.createRoleDTO(roleUser);
    return this.h.post(roleUser.role.ms_base_url + '/permissions/roleusers', roleDTO)
      .map(res => {
        roleUser.id = res.id;
        this.srvUsers.get(roleUser.user_id).subscribe((usr) => {
          roleUser.user_name = usr.name;
          roleUser.user_surname = usr.surname;
          roleUser.user_login = usr.login;
        });
        this.currentRoleUsers.push(roleUser);
      });
  }

  put(roleUser: RoleUserMS) {
    let roleDTO = this.createRoleDTO(roleUser);
    return this.h.put(roleUser.role.ms_base_url + '/permissions/roleusers', roleDTO)
      .map(res => {
        roleUser.id = res.id;
        this.srvUsers.get(roleUser.user_id).subscribe((usr) => {
          roleUser.user_name = usr.name;
          roleUser.user_surname = usr.surname;
          roleUser.user_login = usr.login;
          Object.assign(this.currentRoleUsers.find(ru => ru.id === roleUser.id), roleUser);

        });

      }, this);
  }

  delete(roleUser: RoleUserMS) {
    return this.h.delete(roleUser.role.ms_base_url + '/permissions/roleusers/' + roleUser.id)
      .map(() => {
        this.currentRoleUsers.splice(this.currentRoleUsers.findIndex(ru => ru.id === roleUser.id), 1);
      });
  }

  getUserRoles(userRoleMS: UserRoleMS): Observable<UserRoleModel[]> {
    return this.h.get(userRoleMS.ms_base_url + '/permissions/getRoleUsersByUserId/' + userRoleMS.user_id);
  }

  getFields() {
    if (!this.cachedFields) {
      this.cachedFields = this.h.get('/koncentro-common/schema/RoleUserDto ').pipe(
        publishReplay(1), // this tells Rx to cache the latest emitted
        refCount() // and this tells Rx to keep the Observable alive as long as there are any Subscribers
      )
    }
    return this.cachedFields;
  }

}



// WEBPACK FOOTER //
// ./src/app/services/utils/roleUserMS.service.ts